"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const SearchWithCriteria_1 = __importDefault(require("@Components/Search/SearchWithCriteria"));
const CatalogExportButton_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderCatalog/RightsholderCatalogSearch/CatalogExportButton"));
const MemberWorkIdentifierTooltip_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderCatalog/RightsholderCatalogSearch/MemberWorkIdentifierTooltip"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const WorkResultsTable_1 = __importDefault(require("@Components/WorkItemV2/WorkResultsTable"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Sidebar_1 = require("@Components/Sidebars/Sidebar");
const DownloadSidebar_1 = __importDefault(require("@Components/Sidebars/DownloadSidebar"));
const catalog_search_store_1 = require("@App/stores/search/catalog-search-store");
const CatalogSearch = ({ userStore, catalogSearchStore, searchFilters, claimedShares, compactWorkComponentType, extendedWorkComponentType, }) => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [sidebarIsOpen, setSidebarIsOpen] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        catalogSearchStore.resetSearchCriteriaStore();
        runSearch({
            limit: catalogSearchStore.pagination.limit,
            page: catalogSearchStore.pagination.page,
        }).finally();
    }, []);
    const closeSidebar = () => {
        setSidebarIsOpen(false);
    };
    const reset = () => __awaiter(void 0, void 0, void 0, function* () {
        catalogSearchStore.resetSearchCriteriaStore();
        catalogSearchStore.destroyCatalogCriteria();
        catalogSearchStore.destroyCurrentSearchFilter();
        yield runSearch();
    });
    const runSearch = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (callBackPagination = catalog_search_store_1.defaultCatalogPagination) {
        setLoading(true);
        yield catalogSearchStore.searchForWorks(callBackPagination);
        setLoading(false);
    });
    const runSearchWithNewCriteria = (searchCriteria, filters) => __awaiter(void 0, void 0, void 0, function* () {
        catalogSearchStore.setCatalogSelectionSearchQuery(searchCriteria);
        catalogSearchStore.setCurrentSearchFilters(filters);
        yield runSearch();
    });
    const onChangeLimit = (newLimit) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield catalogSearchStore.changeSearchResultsLimit(newLimit);
        setLoading(false);
    });
    return (react_1.default.createElement("div", { className: 'rightsholder-catalog-wrapper' },
        react_1.default.createElement("section", { className: 'showing-search' },
            react_1.default.createElement(SearchWithCriteria_1.default, { searchCriteriaStore: catalogSearchStore.searchCriteriaStore, canAddCriteria: true, handleSearch: runSearchWithNewCriteria, disableSearchButtons: loading, filterFieldCollections: searchFilters, resetSearchFn: reset, extraButtons: [
                    react_1.default.createElement(CatalogExportButton_1.default, { key: 'export-button', catalogSearchStore: catalogSearchStore, loading: loading, setSidebarIsOpen: setSidebarIsOpen }),
                ], isUniqueTooltip: react_1.default.createElement(MemberWorkIdentifierTooltip_1.default, null) })),
        loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement(WorkResultsTable_1.default, { works: catalogSearchStore.worksRightsHolder, claimedShares: claimedShares, paginationInfo: catalogSearchStore.worksRightsHolderPaginationInfo, limit: catalogSearchStore.limit, onChangePage: runSearch, onChangeLimit: onChangeLimit, compactWorkComponentType: compactWorkComponentType, extendedWorkComponentType: extendedWorkComponentType, compact: userStore.userSettings && userStore.userSettings.showDetailedWorkCards, showCompactToggle: true })),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: sidebarIsOpen, onClose: closeSidebar },
            react_1.default.createElement(Sidebar_1.Sidebar, { onClose: closeSidebar },
                react_1.default.createElement(DownloadSidebar_1.default, { closeSidebar: closeSidebar, sidebarDownloadType: catalogSearchStore.sidebarDownloadType })))));
};
exports.default = (0, mobx_react_1.observer)(CatalogSearch);
